import { atomWithStorage } from "jotai/utils"

const _news = atomWithStorage<Array<string> | null>("inandout.news", null)

export { _news }
